/**
 * Utilitário para obter dados de passeio no idioma correto
 */
export const getPasseioLang = (passeio, lang = 'pt') => {
  if (!passeio) return null;

  const langMap = {
    pt: { name: 'nome_pt', desc: 'descricao_pt', loc: 'localizacao_pt' },
    en: { name: 'nome_en', desc: 'descricao_en', loc: 'localizacao_en' },
    es: { name: 'nome_es', desc: 'descricao_es', loc: 'localizacao_es' }
  };

  const fields = langMap[lang] || langMap.pt;

  return {
    ...passeio,
    nome: passeio[fields.name] || passeio.nome_pt || passeio.nome || '',
    descricao: passeio[fields.desc] || passeio.descricao_pt || passeio.descricao || '',
    localizacao: passeio[fields.loc] || passeio.localizacao_pt || passeio.localizacao || ''
  };
};

export const getPasseiosLang = (passeios, lang = 'pt') => {
  if (!Array.isArray(passeios)) return [];
  return passeios.map(passeio => getPasseioLang(passeio, lang));
};

